import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const tarefaRepository = createRepository({
  path: 'tarefa',
  restApi,
  queryTransform: {
    createdAt: query.gte('createdAt'),
    dataTermino: query.gte('dataTermino'),
    createdAtFim: query.lte('createdAtFim'),
    dataTerminoFim: query.lte('dataTerminoFim'),
    placaCavalo: query.likeAlphaDigits('placaCavalo'),
    cpfMotorista: query.likeDigits('cpfMotorista'),
    nomeMotorista: query.ilike('nomeMotorista'),
    ...paginate
  }
})

const _create = tarefaRepository.create
tarefaRepository.create = async (data, options) => {
  const formData = new FormData()
  formData.append('data', JSON.stringify(data))
  return _create(formData, {
    ...options,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const tarefaOperacaoRepository = {
  operacaoKmm: operacao => {
    return restApi.get(`tarefa/operacao-kmm/${operacao}`)
  }
}

export const tarefaDadosMotoristaRepository = {
  dadosMotorista: cpf => {
    return restApi.get(`tarefa/motorista/${cpf}`)
  }
}

tarefaRepository.pendenteFilial = (id, data) => {
  return restApi.post(`tarefas/${id}/pendenteFilial/`, data)
}

tarefaRepository.finalizada = (id, data) => {
  return restApi.post(`tarefas/${id}/finalizada/`, data)
}

tarefaRepository.liberadoViagem = (id, data) => {
  return restApi.post(`tarefas/${id}/liberadoViagem/`, data)
}

tarefaRepository.liberadoSemMonitoramento = (id, data) => {
  return restApi.post(`tarefas/${id}/liberadoSemMonitoramento/`, data)
}

tarefaRepository.reanalise = (id, data) => {
  return restApi.post(`tarefas/${id}/reanalise/`, data)
}

tarefaRepository.pendenteMotorista = (id, data) => {
  return restApi.post(`tarefas/${id}/pendenteMotorista/`, data)
}

tarefaRepository.cancelada = (id, data) => {
  return restApi.post(`tarefas/${id}/cancelada/`, data)
}

tarefaRepository.analise = (id, data) => {
  return restApi.post(`tarefas/${id}/analise/`, data)
}

tarefaRepository.removerDataTermino = (id, data) => {
  return restApi.post(`tarefas/${id}/removerDataTermino/`, data)
}

tarefaRepository.delegarAssistente = (id, data) => {
  return restApi.post(`tarefas/${id}/delegarAssistente/`, data)
}

export default tarefaRepository
